import styled, { css } from 'styled-components/macro';
import { fontSize, lineHeight, space } from '../../../theme/tokens';
import { SaveChangesButton } from '../../common/elements/Form';
import { ActiveButton, StaffSubHeader } from '../../common/elements/Staff';

export const AssessmentTitle = styled(StaffSubHeader)`
  padding: 0;
  margin: ${space[3]} 0;
  font-size: ${fontSize.xl};
  overflow-wrap: anywhere;
`;

export const QuestionText = styled.p`
  grid-area: question;
  margin: auto 0;
  font-size: ${fontSize.md};
  line-height: ${lineHeight.normal};
  color: ${({ theme }) => theme.headerColour};
  overflow-wrap: anywhere;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  column-gap: ${space[3]};
  min-width: 0;
`;

export const AssessmentTag = styled(ActiveButton).attrs({ as: 'p' })`
  gap: ${space[1]};
  font-size: ${fontSize.xs};
  ${({ active }) =>
    active &&
    css`
      color: ${({ theme }) => theme.lessonHighlight};
    `}
`;

export const ArchiveButton = styled(SaveChangesButton)`
  margin-left: ${space[3]};
`;

export * from '../../common/elements/Assessments';
export * from '../../common/elements/Form';
export * from '../../common/elements/Notifications';
export * from '../../common/elements/Staff';
